<template>
  <v-col>
    <BookingAppBar :booking-form="bookingForm"></BookingAppBar>
    <v-row
        pt-2
        pl-2
    >
      <v-flex
          xs12
          lg4
          xl4
          md4
          pb-2
          pt-1
      >
        <v-card class="small-book-form create-booking-form">
          <v-container class="small-book-form">
            <v-row
                fill-height
                wrap
                align-start
                justify-start
            >
              <v-flex
                  v-if="false"
                  md12
              >
                <BookingNearestDriverSummary
                    :zones="zones"
                    :taxis="getInformationResponse.taxis"
                    :booking-form="bookingForm"
                    @driverIndexUpdated="setDriverEta"
                />
              </v-flex>
              <v-flex
                  md12
                  sm12
              >
                <v-row
                    wrap
                    fill-height
                >
                  <v-flex md12>
                    <CustomerSearchInput
                        :booking-form="bookingForm"
                        :update-mode="updateMode"
                        :show-business-customer-details="showBusinessCustomerForm"
                        @showBusinessCustomer="toggleBusinessUser"
                    />
                  </v-flex>
                  <v-flex
                      v-if="showBusinessCustomerForm"
                      md12
                  >
                    <BusinessCustomerDetailsInput :booking-form="bookingForm"/>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex
                  md12
                  sm12
              >
                <BookingDateTimeInput
                    :driver-e-t-a="driverETA"
                    :booking-form="bookingForm"
                    :hide-asap-toggle="backdate"
                />
              </v-flex>
              <v-flex
                  md12
                  style="margin-top: 10px"
              >
                <v-divider class="py-1 "/>
              </v-flex>
              <v-flex md12>
                <v-row
                    py-1
                    wrap
                >
                  <v-flex
                      class="ml-1"
                      md12
                  >
                    <label class="cmr-book-form-label">{{
                        'Pickup Location ' + (bookingForm.booking.pickup_location.w3w != null ? bookingForm.booking.pickup_location.w3w : '')
                      }}</label>
                    <v-btn
                        v-if="!pickupInfoActive()"
                        x-small
                        fab
                        elevation="0"
                        color="#003A8C"
                        class="small-icon-bg"
                    >
                      <v-icon
                          dark
                          small
                          color="#E6FFFB"
                          @click="activatePickupInfo"
                      >
                        mdi-account
                      </v-icon>
                    </v-btn>
                    <v-btn
                        v-if="pickupInfoActive()"
                        x-small
                        fab
                        elevation="0"
                        color="red"
                        class="small-icon-bg"
                    >
                      <v-icon
                          small
                          color="white"
                          @click="bookingForm.booking.pickup_info.active = false"
                      >
                        visibility_off
                      </v-icon>
                    </v-btn>
                    <v-btn
                        x-small
                        fab
                        elevation="0"
                        color="blue"
                        class="small-icon-bg"
                    >
                      <v-icon
                          small
                          color="white"
                          @click="swapPickupAndDestination()"
                      >
                        swap_horiz
                      </v-icon>
                    </v-btn>
                    <v-btn
                        x-small
                        fab
                        elevation="0"
                        color="blue"
                        class="small-icon-bg"
                    >
                      <v-icon
                          small
                          color="white"
                          @click="addVia()"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>

                    <BookingLocationInput

                        id="pickup_lg"
                        v-model="bookingForm.booking.pickup_location"
                        flat-field
                        :error="bookingForm.errors.pickup_location"
                        @locationChanged="pickupUpdated"
                    />
                  </v-flex>
                  <v-flex md12>
                    <v-row>
                      <v-flex
                          v-if="pickupInfoActive()"
                          md4
                          px-1
                      >
                        <label class="cmr-book-form-label">Name</label>
                        <SimpleTextInput
                            v-model="bookingForm.booking.pickup_info.name"
                            :error="bookingForm.errors.pickup_info"
                        />
                      </v-flex>
                      <v-flex
                          v-if="pickupInfoActive()"
                      >
                        <v-row>
                          <v-flex>
                            <label class="cmr-book-form-label">Contact No.</label>
                            <a
                                v-if="bookingForm.booking.state != null"
                                :href="
                                'tel:' +
                                  formatNumber(
                                    bookingForm.booking.pickup_info.contact_number
                                  )
                              "
                            >
                              <v-btn
                                  x-small
                                  fab
                                  elevation="0"
                                  color="blue"
                                  class="small-icon-bg"
                              >

                                <v-icon
                                    small
                                    color="white"
                                >
                                  phone
                                </v-icon>
                              </v-btn>
                            </a>

                            <SimpleTextInput
                                v-model="bookingForm.booking.pickup_info.contact_number"
                            />
                          </v-flex>
                        </v-row>
                      </v-flex>
                      <v-flex
                          v-if="pickupInfoActive()"
                      >
                        <label class="cmr-book-form-label">Notes</label>
                        <SimpleTextInput
                            v-if="pickupInfoActive()"
                            v-model="bookingForm.booking.pickup_info.notes"
                            :maxlength="300"
                        />
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex md12>
                <v-flex
                    v-for="(destination, index) in bookingForm.booking.destinations"
                    xs12
                    md12
                    grow
                    ml-1
                >
                  <v-row
                      v-if="index > 0"
                      py-1
                      align-start
                      wrap
                  >
                    <v-flex md12>
                      <label class="cmr-book-form-label">{{
                          'Via ' + index + (bookingForm.booking.destinations[index].w3w != null ? bookingForm.booking.destinations[index].w3w : '')
                        }}</label>
                      <v-btn
                          v-if="!viaActive(bookingForm.booking.via_info[index - 1])"
                          x-small
                          fab
                          elevation="0"
                          color="#003A8C"
                          class="small-icon-bg"
                      >
                        <v-icon
                            small
                            color="#E6FFFB"
                            @click="
                            () => {
                              activateViaInfo(index);
                            }
                          "
                        >
                          mdi-account
                        </v-icon>
                      </v-btn>
                      <v-btn
                          v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                          x-small
                          fab
                          elevation="0"
                          color="red"
                          class="small-icon-bg"
                      >
                        <v-icon
                            class="ml-1"
                            small
                            color="white"
                            @click="
                            bookingForm.booking.via_info[index - 1].active = false
                          "
                        >
                          visibility_off
                        </v-icon>
                      </v-btn>

                      <BookingLocationInput
                          :id="'destination_lg' + index"
                          v-model="bookingForm.booking.destinations[index]"
                          flat-field
                          :removable="true"
                          :deletable="index > 0"
                          :error="bookingForm.errors[`destination_${index}`]"
                          @locationChanged="viaUpdated"
                          @removePressed="
                          () => {
                            removeVia(index);
                          }
                        "
                      />
                    </v-flex>
                  </v-row>
                  <v-row
                      wrap
                  >
                    <v-flex md12>
                      <v-row>
                        <v-flex
                            v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                            md4
                        >
                          <label class="cmr-book-form-label">Name</label>
                          <SimpleTextInput
                              v-model="bookingForm.booking.via_info[index - 1].name"
                              :error="bookingForm.errors[`via_info_${index - 1}`]"
                          />
                        </v-flex>
                        <v-flex
                            v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                            ml-1
                        >
                          <v-row>
                            <v-flex shrink>
                              <label class="cmr-book-form-label">Contact No.</label>
                              <a
                                  v-if="bookingForm.booking.state != null"
                                  :href="
                                  'tel:' +
                                    formatNumber(
                                      bookingForm.booking.via_info[index - 1]
                                        .contact_number
                                    )
                                "
                              >
                                <v-btn
                                    x-small
                                    fab
                                    elevation="0"
                                    color="blue"
                                    class="small-icon-bg"
                                >
                                  <v-icon
                                      small
                                      color="white"
                                  >
                                    phone
                                  </v-icon>
                                </v-btn>
                              </a>
                              <SimpleTextInput
                                  v-model="
                                  bookingForm.booking.via_info[index - 1]
                                    .contact_number
                                "
                              />
                            </v-flex>
                          </v-row>
                        </v-flex>
                        <v-flex
                            v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                        >
                          <label class="cmr-book-form-label">Notes</label>
                          <SimpleTextInput
                              v-model="bookingForm.booking.via_info[index - 1].notes"
                              :maxlength="300"
                          />
                        </v-flex>
                      </v-row>
                    </v-flex>
                  </v-row>
                </v-flex>
              </v-flex>
              <v-flex md12>
                <v-row wrap>
                  <v-flex
                      px1
                      pt-1
                      md12
                      class="ml-1"
                  >
                    <label class="cmr-book-form-label"> {{
                        'Destination Location' + (bookingForm.booking.destinations[0].w3w != null ? bookingForm.booking.destinations[0].w3w : '')
                      }} &nbsp;<b
                          v-if="arriveByTime"
                          class="mrc-blue-ribbon"
                      ><span class="mrc-blue-ribbon">Arrive:</span> {{ arriveByTime }}</b>&nbsp; </label>
                    <v-btn
                        v-if="!destinationInfoActive()"
                        x-small
                        fab
                        elevation="0"
                        color="#003A8C"
                        class="small-icon-bg"
                    >
                      <v-icon
                          small
                          color="#E6FFFB"
                          @click="
                          () => {
                            activateDestinationInfo();
                          }
                        "
                      >
                        mdi-account
                      </v-icon>
                    </v-btn>
                    <v-btn
                        v-if="destinationInfoActive()"
                        x-small
                        fab
                        elevation="0"
                        color="red"
                        class="small-icon-bg"
                    >
                      <v-icon
                          small
                          color="white"
                          @click="bookingForm.booking.destination_info.active = false"
                      >
                        visibility_off
                      </v-icon>
                    </v-btn>

                    <BookingLocationInput
                        id="destination_lg"
                        v-model="bookingForm.booking.destinations[0]"
                        flat-field
                        :error="bookingForm.errors['destination_0']"
                        @locationChanged="destinationUpdated"
                    />
                  </v-flex>
                  <v-flex md12>
                    <v-flex
                        v-if="destinationInfoActive"
                        md12
                        ml-1
                    >
                      <v-row>
                        <v-flex
                            v-if="destinationInfoActive()"
                            pt-1
                        >
                          <label class="cmr-book-form-label">Name</label>
                          <SimpleTextInput
                              v-model="bookingForm.booking.destination_info.name"
                              :error="bookingForm.errors.destination_info"
                          />
                        </v-flex>
                        <v-flex
                            v-if="destinationInfoActive()"
                            pl-1
                            pt-1
                        >
                          <v-row>
                            <v-flex>
                              <label class="cmr-book-form-label">Contact No.</label>

                              <a
                                  v-if="bookingForm.booking.state != null"
                                  :href="
                                  'tel:' +
                                    formatNumber(
                                      bookingForm.booking.destination_info.contact_number
                                    )
                                "
                              >
                                <v-btn
                                    x-small
                                    fab
                                    elevation="0"
                                    color="blue"
                                    class="small-icon-bg"
                                >
                                  <v-icon
                                      small
                                      color="white"
                                  >
                                    phone
                                  </v-icon>
                                </v-btn>
                              </a>
                              <SimpleTextInput
                                  v-model="
                                  bookingForm.booking.destination_info.contact_number
                                "
                              />
                            </v-flex>
                          </v-row>
                        </v-flex>
                        <v-flex
                            v-if="destinationInfoActive()"
                            pt-1
                        >
                          <label class="cmr-book-form-label">Notes</label>
                          <SimpleTextInput
                              v-if="destinationInfoActive()"
                              v-model="bookingForm.booking.destination_info.notes"
                              :maxlength="300"
                          />
                        </v-flex>
                      </v-row>
                    </v-flex>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex md12>
                <v-divider
                    style="margin-left: 12px; margin-top: 10px; margin-bottom: 5px"
                />
              </v-flex>
              <v-flex md12>
                <VehicleRequirementsInput :booking-form="bookingForm"/>
              </v-flex>
              <v-flex md12>
                <PassengerFindDetails :booking-form="bookingForm"/>
              </v-flex>
              <v-flex md12>
                <BookingDispatchInput :booking-form="bookingForm"/>
              </v-flex>
              <v-flex md12>
                <UserNotes
                    :booking-form="bookingForm"
                    @updateNotes="updateNotes"
                />
              </v-flex>
              <v-flex
                  md12
                  lg12
                  xl12
              >
                <v-divider
                    style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px; margin-top: 10px"
                />
              </v-flex>
              <v-flex
                  md12
                  lg12
                  xl12
              >
                <PaymentInput
                    :booking-form="bookingForm"
                    @updateFinalCosts="updateFinalCosts"
                />
              </v-flex>
              <v-flex
                  md12
                  lg12
                  xl12
              >
                <v-divider
                    style="margin-left: 12px; margin-top: 2px; margin-bottom: 5px; margin-top: 10px"
                />
              </v-flex>
            </v-row>
          </v-container>
          <v-col
              v-if="bookingForm != null && bookingForm.booking != null"
              class="small-book-form"
              align-content-start
          >
            <v-flex pb-2>
              <BookRideOptions
                  :backdate="backdate"
                  :update-mode="updateMode"
                  :booking-form="bookingForm"
                  @update="bookingForm.updateRide(updatedBooking)"
                  @confirmTrip="bookingForm.updateRide(rideConfirmed)"
                  @book="bookingForm.bookRide(madeBooking)"
                  @backdate="bookingForm.backdateRide(madeBooking)"
                  @cancel="
                  (params) => {
                    bookingForm.cancelRide(cancelledBooking, params);
                  }
                "
                  @change="showChangeUser"
              />
            </v-flex>
          </v-col>
        </v-card>
      </v-flex>
      <v-flex
          xs8
          lg8
          xl8
          md8
      >
        <v-row>
          <v-flex
              v-if="bookingForm != null && bookingForm.booking != null"
              xs12
              md12
              lg12
              xl12
          >
            <v-container fluid>
              <v-row wrap>
                <v-flex
                    lg6
                    xl6
                    md6
                >
                  <v-row>
                    <v-flex
                        md12
                        lg12
                        xl12
                        sm12
                        xs12
                    >
                      <v-card class="mb-1">
                        <v-row
                            wrap
                        >
                          <v-flex
                              md12
                              lg12
                              xl12
                              xm12
                              xs12
                          >
                            <OverwatchMap
                                ref="bookingMap"
                                :enable-drag-to-update="true"
                                :taxis="getInformationResponse.taxis"
                                :bookings="getInformationResponse.jobs"
                                :show-state-summary="false"
                                style="height: 400px"
                                :selected-taxi="showSelectedTaxiId"
                                :set-selected-taxi="selectedTaxiIdFnIfNull"
                                :zone="bookingForm != null ? bookingForm.booking.zone : null"
                                @placechanged="locationChanged"
                            />
                          </v-flex>
                          <v-flex
                              md12
                              lg12
                              xl12
                              xm12
                              xs12
                          >
                            <v-row
                                v-if="bookingForm.booking.driver_trace != null || bookingForm.booking.route.route_geometry != null"
                                wrap
                            >
                              <v-btn-toggle
                                  v-if="bookingForm.booking.driver_trace != null"
                                  v-model="showingDriverTrace"
                                  small
                                  :disabled="!enableShowDriverTrace"
                                  class="pa-1 pr-0"
                                  @change="showDriverTrace"
                              >
                                <v-btn
                                    :value="1"
                                    small
                                    class="text-capitalize"
                                >
                                  Driver Route
                                </v-btn>
                              </v-btn-toggle>
                              <p>&nbsp;&nbsp;</p>
                              <v-btn-toggle
                                  v-if="bookingForm.booking.route.route_geometry != null"
                                  v-model="selectShowSuggestedRoute"
                                  class="pa-1 pl-0"
                                  label="Show suggested route"
                                  @change="showBookingRoute"
                              >
                                <v-btn
                                    :value="1"
                                    small
                                    class="text-capitalize"
                                >
                                  Suggested Route
                                </v-btn>
                              </v-btn-toggle>
                            </v-row>
                          </v-flex>
                        </v-row>
                      </v-card>
                    </v-flex>
                    <v-flex
                        md12
                        lg12
                        xl12
                        sm12
                        xs12
                    >
                      <v-row>
                        <v-flex
                            xl12
                            md12
                            lg12
                        >
                          <v-card class="pa-2">
                            <v-flex
                                mt-1
                            >
                              <v-row
                                  column
                              >
                                <h5 v-if="bookingForm.user.recent_bookings.length > 0">
                                  Recent Trips
                                </h5>
                                <UserRecentBookings
                                    v-if="bookingForm.user.recent_bookings.length > 0"
                                    :booking-form="bookingForm"
                                    :rebook="rebook"
                                />
                                <h5 v-if="bookingForm.user.booked_bookings.length > 0">
                                  Booked Trips
                                </h5>
                                <UserBookedBookings
                                    v-if="bookingForm.user.booked_bookings.length > 0"
                                    :booking-form="bookingForm"
                                    :rebook="rebook"
                                />
                                <h5 v-if="bookingForm.user.active_bookings.length > 0">
                                  Active Trips
                                </h5>
                                <UserActiveBookings
                                    v-if="bookingForm.user.active_bookings.length > 0"
                                    :booking-form="bookingForm"
                                />
                              </v-row>
                            </v-flex>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-flex>
                  </v-row>
                </v-flex>
                <v-flex
                    grow
                    lg6
                    md6
                    xl6
                >
                  <v-flex
                      ml-2
                      xs12
                      md12
                      lg12
                      xl12
                  >
                    <v-card class="custom-card">
                      <v-flex px-2>
                        <v-row
                            v-if="updateMode == true"
                            column
                            pt-2
                        >
                          <h5>Booking Timeline</h5>
                          <Timeline :booking="bookingForm.booking" :user="bookingForm.user"/>

                          <h5 style="padding-top: 12px">
                            Payment Details
                          </h5>
                          <v-divider/>
                          <SumupTransaction
                              v-if="bookingForm.booking.payment_type == 'card_in_cab'"
                              :booking-form="bookingForm"
                          />
                          <StripeTransaction
                              v-if="bookingForm.booking.payment_type == 'card'"
                              :booking-form="bookingForm"
                          />
                          <StripeCancellationFee
                              v-if="bookingForm.booking.booking_cancellation_fee != null"
                              :booking-form="bookingForm"
                          />
                          <v-flex pt-2>
                            <SendReceipt :booking-form="bookingForm"/>
                          </v-flex>
                        </v-row>
                        <v-row v-if="updateMode == true">
                          <v-flex
                              class="rounded-container"
                              pt-2
                          >
                            <BookingReviewSummary :booking-form="bookingForm"/>
                          </v-flex>
                        </v-row>
                        <v-row
                            v-if="bookingForm != null && updateMode == true && bookingForm.booking.state == 'completed'">
                          <v-flex
                              class="rounded-container"
                              pt-2
                          >
                            <BookingAdditionalSummary :booking-form="bookingForm"/>
                          </v-flex>
                        </v-row>
                      </v-flex>
                    </v-card>
                    <v-card
                        class="custom-card"
                        v-if="flightTrackingFeatureFlag !== 0 && bookingForm.booking.flight_number !== '' && bookingForm.booking.flight_number != null && updateMode === true && bookingForm.booking.state !== 'completed' && this.bookingForm.booking.state !== 'cancelled' ">
                      <v-flex px-2 pb-5>
                        <v-row>
                          <v-flex
                              class="rounded-container"
                              pt-2
                          >
                            <FlightInformation
                                ref="flightInformationComponentRef"
                                :flight_iata="bookingForm.booking.flight_number"
                                :flight_date="bookingForm.booking.pickup_date"/>
                          </v-flex>
                        </v-row>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-row>
            </v-container>
          </v-flex>
        </v-row>
      </v-flex>
      <v-dialog
          v-model="changeUserDialog"
          persistent
          :width="450"
      >
        <v-card v-if="bookingForm.booking != null">
          <v-card-title
              primary-title
              class="headline grey lighten-1"
          >
            <v-row
                align-center
                justify-center
            >
              <span
                  class="title font-weight-light white--text"
                  style="line-height: 18pt !important"
              >
                Change User for booking:
                <b>{{ bookingForm.booking.id }}</b>
              </span>
            </v-row>
          </v-card-title>
          <v-flex
              px-3
              py-2
          >
            <v-flex xs12>
              <v-autocomplete
                  v-model="customer"
                  :items="customers"
                  :loading="loading"
                  :search-input.sync="search"
                  item-text="descriptor"
                  label="Customer Search*"
                  hide-no-data
                  hide-selected
                  no-filter
                  return-object
                  required
                  @change="customerSelected"
              />
            </v-flex>
          </v-flex>
          <v-card-actions>
            <v-row justify-end>
              <v-btn
                  color="red darken-1"
                  flat
                  @click="changeUserDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                  color="green darken-1"
                  flat
                  @click="changeUser"
              >
                Update
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
import {Overwatch} from "@/components/util/Overwatch.js";
import moment from 'moment'

import ActiveTrips from "@/components/overwatch/ActiveTrips.vue";
import TaxiList from "@/components/overwatch/TaxiList.vue";
import ZoneList from "@/components/overwatch/ZoneList.vue";
import TaxiZonesSummary from "@/components/overwatch/TaxiZonesSummary.vue";
import TaxiZoneSummary from "@/components/overwatch/TaxiZoneSummaryV2.vue";
import BookingZonesSummary from "@/components/overwatch/BookingZonesSummary.vue";
import BookingZoneSummary from "@/components/overwatch/BookingZoneSummaryV2.vue";

import UserActiveBookings from "@/components/overwatch/UserActiveBookings.vue";
import UserBookedBookings from "@/components/overwatch/UserBookedBookings.vue";
import UserRecentBookings from "@/components/overwatch/UserRecentBookings.vue";

import Timeline from "@/components/booking/TimelineV2.vue";

import BookingLocationInput from "@/components/widget/input/BookingLocationInputV2.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import BookingDateTimeInput from "@/components/widget/input/BookingDateTimeInputV2.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import BookingReviewSummary from "@/components/rating/BookingReviewSummary.vue";
import BookingAdditionalSummary from "@/components/booking/BookingAdditionalSummary.vue";

import SendReceipt from "@/components/booking/SendReceipt.vue";

import BookingActions from "@/components/widget/input/BookingActions.vue";
import BookRideOptions from "@/components/widget/input/BookRideOptionsV2.vue";
import BusinessCustomerDetailsInput from "@/components/widget/input/BusinessCustomerDetailsInputV2.vue";
import VehicleRequirementsInput from "@/components/widget/input/VehicleRequirementsInputV2.vue";
import PassengerFindDetails from "@/components/widget/input/PassengerFindDetailsV2.vue";
import PaymentInput from "@/components/widget/input/PaymentInputV2.vue";
import BookingDispatchInput from "@/components/widget/input/BookingDispatchInputV2.vue";
import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import SumupTransaction from "@/components/booking/SumupTransactionV2.vue";
import StripeTransaction from "@/components/booking/StripeTransactionDetailsV2.vue";
import StripeCancellationFee from "@/components/booking/StripeCancellationFeeV2.vue";

import CustomerSearchInput from "@/components/widget/input/CustomerSearchInputV2.vue";
import UserNotes from "@/components/widget/input/UserNotesV2.vue";

import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

import {replaceStart} from "@/components/util/PhoneNumbers.js";


import BookingNearestDriverSummary from "@/components/widget/input/BookingNearestDriverSummaryV2.vue";
import DriverPaymentInput from '../../widget/input/DriverPaymentInput'
import BookingAppBar from '../BookingAppBar'
import FlightInformation from "../FlightInformation.vue";

export default {
  name: "NewLargeBookForm",
  components: {
    BookingAppBar,
    DriverPaymentInput,
    BookingAdditionalSummary,
    BookingDispatchInput,
    BookingLocationInput,
    SimpleTextInput,
    BookingActions,
    StripeCancellationFee,
    SelectableInput,
    BookingDateTimeInput,
    BusinessCustomerDetailsInput,
    VehicleRequirementsInput,
    PassengerFindDetails,
    PaymentInput,
    CustomerSearchInput,
    UserNotes,
    OverwatchMap,
    BookTripETARoute,
    CardInput,
    PromocodeInput,
    UserActiveBookings,
    UserRecentBookings,
    BookRideOptions,
    Timeline,
    SumupTransaction,
    StripeTransaction,
    SendReceipt,
    BookingReviewSummary,
    SimpleCard,
    UserBookedBookings,
    TaxiList,
    ZoneList,
    BookingNearestDriverSummary,
    TaxiZoneSummary,
    TaxiZonesSummary,
    BookingZoneSummary,
    BookingZonesSummary,
    ActiveTrips,
    FlightInformation
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    filters: {
      type: Boolean,
      default: false
    },
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    setSelectedTaxi: Function,
    selectedTaxi: Number,
    expand: Function,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    backdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectShowSuggestedRoute: 0,
      selectedShowDriverTrace: 0,
      driverETA: '',
      minutesFromPickup: 0,
      showSelectedTaxiId: "",
      selectedTaxiZoneId: "",
      showBusinessCustomerForm: false,
      bookingPickupDate: '',
      rideType: '',
      taxiType: '',
      changeUserDialog: false,
      customers: [],
      customer: {},
      search: null,
      bookingReturn: false,
      loading: false,
      showingDriverTrace: false,
      getDriverLocationTimer: null,
      getInformationTimer: null,
      getBestDriverTimer: null,
      getInformationResponse: {
        taxis: [],
        bookings: [],
        ride_type_etas: [],
      },
      taxiListMode: "ride_types",
      toggleDisabled: false,
      zones: [],
      flight_number: '',
      flight_date: ''
    };
  },
  computed: {
    selectedTaxiIdFnIfNull() {
      if (this.selectedTaxi != null) {
        return this.selectedTaxi
      }
      return this.setSelectedTaxiIfNull
    },
    /*
        bookingRideType () {
          return this.bookingForm.booking.ride_type;
        },
        bookingTaxiType () {
          return this.bookingForm.booking.taxi_type;
        },
    */
    arriveByTime: function () {
      if (this.bookingForm.booking.route.time == null) {
        return "";
      }

      return this.calculateArriveByTime(
          this.bookingForm.booking.route.time
      );
    },
    bookingPickupDateTime() {
      return this.bookingForm.booking.pickup_date + ' ' + this.bookingForm.booking.pickup_time
    },
    formattedPickupDateTime() {
      if (moment(this.bookingPickupDateTime).isValid()) {
        return this.bookingPickupDateTime
      }
      return ''
    },
    enableShowDriverTrace: function () {
      return !(
          this.bookingForm.booking.state == "accepted" ||
          this.bookingForm.booking.state == "pob"
      );
    },
    userIsBusiness: function () {
      return this.bookingForm.user.business == true;
    },
    bookingIsCompletedOrCancelled() {
      return (
          this.bookingForm.booking.state == "completed" ||
          this.bookingForm.booking.state == "cancelled"
      );
    },
    flightTrackingFeatureFlag: function () {
      return this.$store.getters.getFlightTrackingFeatureFlag;
    },
  },
  watch: {
    showSelectedTaxiId() {
      this.setSelectedTaxiIfNull(this.showSelectedTaxiId)
      // this.$refs.bookingMap.zoomToTaxi(this.showSelectedTaxiId);
    },
    bookingPickupDateTime() {
      if (moment(this.bookingPickupDateTime).isValid()) {
        this.applyFilters()
      }
    },
    /*
        bookingRideType () {
          this.applyFilters()
        },
        bookingTaxiType () {
          this.applyFilters()
        },
    */
    search(val) {
      console.log(val);

      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
          .then(function (res) {
            searchCompleted(res.data);
          })
          .catch(function (err) {
            console.error(err);
            this.loading = false;
          });
    },
  },
  beforeDestroy: function () {
    clearTimeout(this.getDriverLocationTimer);
    clearTimeout(this.getInformationTimer);

    this.getInformationTimer = null;
  },
  mounted: function () {
    if (this.bookingForm.booking.business_customer_name) {
      this.showBusinessCustomerForm = true
    }
    var centerToBooking = this.centerToBooking;
    setTimeout(centerToBooking, 2000);

    var vm = this;

    this.getDriverLocationTimer = setInterval(function () {
      vm.getDriverLocation();
    }, 5000);

    if (
        this.bookingForm.booking.state == null ||
        (this.bookingForm.booking.state != "completed" &&
            this.bookingForm.booking.state != "cancelled")
    ) {
      if (this.filters) {
        this.getInformationTimer = setTimeout(this.getInformation, 2000);
        // this.getBestDriverTimer = setTimeout(this.bookingForm.getBestDriver, 2000);
      }

      // else {
      //   this.getInformationTimer = setTimeout(this.getInformation, 2000);
      // }
    }

    this.getZones();

    if (this.setSelectedTaxi == null) {
      // this.setSelectedTaxi = this.setSelectedTaxiIfNull;
    }
    if (this.filters) {
      this.getInformation()
    }
  },
  methods: {
    setSelectedBooking: function (bookingID, taxiID) {
      if (bookingID != -1) {
        this.setSelectedTaxi(-1);
      }

      if (this.selectedBooking == bookingID) {
        console.log("resetting");
        this.selectedBooking = -1;
        return;
      } else {
        this.selectedBooking = bookingID;
      }

      console.log("Booking ID " + bookingID);
      console.log("Taxi ID " + taxiID);

      var taxi = null;

      if (taxiID != null) {
        taxi = this.taxis.find(function (t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          this.selectedTaxi = taxi.id;
          console.log("Got taxi " + this.selectedTaxi);
        }

        try {
          if (this.selectedTaxi != -1) {
            var elem = document.getElementById(this.selectedTaxi);
            elem.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          } else {
            var elem = document.getElementById("activeTable-header-row");
            elem.scrollIntoView(true);
          }
        } catch (e) {
          console.log(e);
          // taxi had no booking
        }
      }

      var booking = null;

      if (bookingID != -1) {
        booking = this.bookings.find(function (b) {
          return b.id == bookingID;
        });
      }

      if (booking == null) {
        console.log("Booking was null");
        return;
      }

      this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
      this.$refs.taxiMap.zoomToBookingTaxi(booking, taxi);
    },
    setDriverEta(eta) {
      this.driverETA = eta.pickupTimeETA
      this.showSelectedTaxiId = eta.driver && eta.driver.taxi && eta.driver.taxi.id ? eta.driver.taxi.id : 0
      this.bookingForm.booking.selected_taxi_zone_id = eta.driver && eta.driver.taxi && eta.driver.taxi.taxi_zone_info ? eta.driver.taxi.taxi_zone_info.id : 0
      this.minutesFromPickup = eta.minutesFromPickup
    },
    async fix495DriverChat() {
      /*
            let drivers = [
              496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507
            ];
      */
      let drivers = [
        508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522
      ];
      for (let i = 0; i < drivers.length; i++) {
        var url = `${this.$store.state.apiUrl}/driver/add_conversation_participant/${drivers[i]}`

        try {
          let response = await axios.get(url, {
            params: {},
          })
          console.log(drivers[i] + " chat fixe", response)
        } catch (e) {
          console.log(e)
        }
      }
    },
    calculateArriveByTime: function (minutes) {
      if (this.bookingForm.booking.pickup_time && minutes) {
        return moment(this.bookingForm.booking.pickup_time, 'HH:mm').add((minutes + this.minutesFromPickup), 'm').format("HH:mm")
      }
      return null
    },
    toggleBusinessUser(status) {
      this.showBusinessCustomerForm = status
    },
    applyFilters() {
      if (this.filters) {
        if (this.bookingPickupDateTime) {
          this.bookingPickupDate = moment(this.bookingPickupDateTime).format("YYYY-DD-MM HH:MM")
        }
        if (this.bookingRideType) {
          this.rideType = this.bookingRideType
        }
        if (this.bookingTaxiType) {
          this.rideType = this.bookingTaxiType
        }
        this.getInformation()
      }
    },
    getDriverLocation: async function () {
      if (
          this.bookingForm.booking.state == null ||
          this.bookingIsCompletedOrCancelled
      ) {
        clearInterval(this.getDriverLocationTimer);
        return;
      }

      try {
        let response = await axios.get(
            `${this.$store.state.apiUrl}/booking/getDriverTraceForLiveDisplay?id=${this.bookingForm.booking.id}`,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        this.bookingForm.booking.driver_trace = response.data.driver_trace;

        this.showDriverTrace(false);
        this.showDriverTrace(true, false);
      } catch (error) {
        console.log(error);
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    showChangeUser: function () {
      console.log("Show change user dialog");
      this.changeUserDialog = true;
    },
    changeUser: async function () {
      this.changeUserDialog = false;

      try {
        let response = await axios.post(
            `${this.$store.state.apiUrl}/booking/changeUser?booking_id=${this.bookingForm.booking.id}&user_id=${this.customer.id}`,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error == "no_error") {
          alert("Booking User updated");
          this.bookingForm.getCustomer(this.customer.contact_number);
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    customerSelected: function (customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    searchCompleted: function (data) {
      this.customers = data.customers;

      this.customers.forEach(function (c) {
        c.descriptor = c.name + " " + c.contact_number;
      });

      this.loading = false;
    },
    showDriverTrace: function (selected, recenter) {
      if (selected) {
        var driverTrace = this.bookingForm.booking.driver_trace;

        console.log(driverTrace);

        this.$refs.bookingMap.showDriverTrace(
            driverTrace,
            this.bookingForm.booking,
            recenter,
            !this.enableShowDriverTrace
        );
      } else {
        console.log("hiding driver trace");
        this.$refs.bookingMap.hideDriverTrace();
      }
    },
    showBookingRoute: function (selected) {

      if (selected) {
        var geometry = this.bookingForm.booking.route.route_geometry;

        console.log(geometry);

        this.$refs.bookingMap.showBookingRoute(geometry);
      } else {
        this.$refs.bookingMap.hideBookingRouteTrace();
      }
    },
    updateFinalCosts: function () {
      console.log("Updating final costs");
      this.bookingForm.updateFinalCosts();
    },
    updateNotes: function () {
      console.log("Updating notes");
      this.bookingForm.updateNotes();
    },
    cancelledBooking: function () {
      this.$emit("cancelledBooking", null);
    },
    madeBooking: function () {
      this.$emit("madeBooking", null);
    },
    updatedBooking: function () {
      this.$emit("updatedBooking", null);
      this.$refs.flightInformationComponentRef.getFlightInformation();
    },
    rideConfirmed: function () {
      this.$emit("rideConfirmed", null);
    },
    swapPickupAndDestination: function () {
      this.bookingForm.swapPickupAndDestination();
      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activatePickupInfo: function () {
      this.bookingForm.booking.pickup_info.active = true;
    },
    pickupInfoActive: function () {
      return (
          this.bookingForm.booking.pickup_info != null &&
          this.bookingForm.booking.pickup_info.active == true
      );
    },
    activateDestinationInfo: function () {
      this.bookingForm.booking.destination_info.active = true;
    },
    destinationInfoActive: function () {
      return (
          this.bookingForm.booking.destination_info != null &&
          this.bookingForm.booking.destination_info.active == true
      );
    },
    centerToBooking: function () {
      try {
        this.$refs.bookingMap.zoomToMakingBooking(this.bookingForm.booking);
      } catch (e) {
        console.log(e);
      }
    },
    addVia: function () {
      this.bookingForm.addVia();
    },
    getCostEstimate: function (loc) {
      this.bookingForm.getCostEstimate();
    },
    pickupUpdated: function (loc) {
      this.bookingForm.booking.pickup_location = loc;
      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    destinationUpdated: function (loc) {
      this.bookingForm.booking.destinations[0] = loc;
      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    locationChanged: function (loc) {
      this.getCostEstimate();
    },
    viaUpdated: function (loc) {
      this.centerToBooking();
      this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    viaActive: function (via) {
      return via != null && via.active != null && via.active == true;
    },
    removeVia: function (index) {
      this.bookingForm.booking.destinations.splice(index, 1);
      this.bookingForm.booking.via_info.splice(index - 1, 1);

      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activateViaInfo: function (index) {
      this.bookingForm.booking.via_info[index - 1].active = true;
      this.$forceUpdate();
    },
    rebook(booking) {
      this.bookingForm.rebook(booking);

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    getInformation: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/overwatch/getInformation?hoursToShow=1&historyToReturn=0`;
        if (this.filters) {
          url += `&mode=filters`
        }
        if (this.formattedPickupDateTime) {
          url += `&dateTime=${this.formattedPickupDateTime}`
        }
        /*
                if (this.bookingRideType) {
                  url += `&rideType=${this.bookingRideType}`
                }
                if (this.bookingTaxiType) {
                  url += `&taxiType=${this.bookingTaxiType}`
                }
        */
        let response = await axios.get(url, {
          params: {},
        });

        // console.log(response.data);

        this.lastUpdateTime = new Date();

        this.getInformationResponse = response.data;

        try {
          // console.log(this);
          this.$refs.bookingMap.updateMarkers(-1);
        } catch (error) {
          console.log(error);
        }

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 3000);
        }
        // if (this.getBestDriverTimer != null) {
        //   setTimeout(this.getBestDriverTimer.bind(this), 3000);
        // }
      } catch (error) {
        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 3000);
        }
        // if (this.getBestDriverTimer != null) {
        //   setTimeout(this.getBestDriverTimer.bind(this), 3000);
        // }
        console.log("Failed to get information " + error);
      }
    },
    getZones: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/zones/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.zones = response.data.zones;
        this.$store.state.use_zone_based_dispatch =
            response.data.use_zone_based_dispatch;

        console.log("got zones");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get zones " + error);
      }
    },
    setSelectedTaxiIfNull: function (taxiID) {
      console.log(taxiID);

      if (this.selectedTaxi == taxiID) {
        this.selectedTaxi = -1;
      } else {
        this.selectedTaxi = taxiID;
      }

      try {
        if (this.selectedTaxi != -1) {
          var elem = document.getElementById(this.selectedTaxi);
          elem.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
        } else {
          var elem = document.getElementById("activeTable-header-row");
          // elem.scrollIntoView(true);
        }
      } catch (e) {
        console.log(e);
        // taxi had no booking
      }

      try {
        // console.log(this);
        this.$refs.bookingMap.updateMarkers(this.selectedTaxi);
        this.$refs.bookingMap.zoomToTaxi(this.selectedTaxi);
      } catch (e) {
        console.log(e);

      }

      // highlight in table

      // highlight in summary
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.v-input__control {
  font-size: 11px !important;
  /*background: white !important;*/
}

.small-table-text ul {
  list-style: none;
  padding-left: 0px !important;
}

.small-table-text td {
  font-size: 11px !important;
}

.small-table-text tr:nth-child(even) {
  background-color: #f7f7f7;
}

.taxi-list-header {
  color: #10425a;
}

.small-button {
  font-size: 12px !important;
}

.disabled-panel {
  pointer-events: none;
}

// .small-book-form .v-text-field {
//   padding-top: 4px !important;
//   margin-top: 4px !important;
// }

.rounded-container {
  background-color: white;
  border-radius: 8px;
}

.visibility-toggle {
  margin-top: -2px;
}


.theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
  color: #595959 !important;
}

.v-input__control {
  font-weight: 500 !important;
}


.small-book-form .v-input__slot {
  min-height: 20px !important;
}

.change-cost-panel {
  padding: 8px;
  //background-color: #e3f2fd;
  background-color: #FFFFFF !important;
}

.custom-card {
  margin-bottom: 16px;
}


</style>
